import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';
import { LoginPopUp, SignUpPopUp } from "../../components";
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const Navbar = ({ setNavbarHeight }) => {

    const { t } = useTranslation();
    // Logo onclick
    const navigate = useNavigate();
    const [pictureSrc, setPictureSrc] = useState("");

    const Menu = () => (
        <>
            <p className="nav-link"><a href="#home" onClick={() => navigate('/')}>{t('Home')}</a></p>
            <p className="nav-link"><a href="#concept" onClick={() => navigate('/#concept')}>{t('Concept')}</a></p>
            <p className="nav-link"><a href="#app" onClick={() => navigate('/#app')}>{t('App')}</a></p>
            <p className="nav-link"><a href="#dates" onClick={() => navigate('/#dates')}>{t('Calender')}</a></p>
            <p className="nav-link"><a href="#faq" onClick={() => navigate('/#faq')}>{t('FAQ')}</a></p>
        </>
    )

    function navigateHomeAndScrollToTop() {
        navigate('/');
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
    }

    // scrolled für blackening
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Höhe Navbar berechnen
    useEffect(() => {
        if (setNavbarHeight) {
            const navbarElement = document.querySelector('.navbarHomepage');
            if (navbarElement) {
                const navbarHeight = navbarElement.offsetHeight;
                setNavbarHeight(navbarHeight);
            }
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 6; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, [setNavbarHeight]);

    // whatever???
    const [toggleMenu, setToggleMenu] = useState(false);
    const [buttonPopUp_Login, setButtonPopUp_Login] = useState(false);
    const [buttonPopUp_SignUp, setButtonPopUp_SignUp] = useState(false);

    if (buttonPopUp_Login) {
        document.body.classList.add('active_Login-popUp')
    } else {
        document.body.classList.remove('active_Login-popUp')
    }

    if (buttonPopUp_SignUp) {
        document.body.classList.add('active_SignUp-popup')
    } else {
        document.body.classList.remove('active_SignUp-popup')
    }

    return (
        <div className={`navbarHomepage ${scrolled ? "scrolled" : ""}`}>
            {pictureSrc ? (
                <img className="logo" onClick={navigateHomeAndScrollToTop} src={pictureSrc} alt="Barmatch" />
            ) : (
                <p>Loading logo...</p>
            )}
            <nav className="navigation">
                <Menu></Menu>
                <button id="login-button" onClick={() => setButtonPopUp_Login(true)}>{t('SignIn')}</button>
                <button id="signup-button" onClick={() => setButtonPopUp_SignUp(true)}>{t('SignUp')}</button>
            </nav>

            <div className="barmatch_navbar-menu">
                {toggleMenu
                    ? <RiCloseLine color="#ffffff" size={27} onClick={() => setToggleMenu(false)} />
                    : <RiMenu3Line color="#ffffff" size={27} onClick={() => setToggleMenu(true)} />
                }
                {toggleMenu && (
                    <div className="barMatch_navbar-menu_container  scale-up-center">
                        <div className="barmatch_navbar-menu_container-links">
                            <Menu></Menu>
                            <div className="barmatch_navbar-menu_container-links-sign">
                                <p>{t('SignIn')}</p>
                                <Link to="../components/profile"><button type="button">{t('SignUp')}</button></Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <LoginPopUp trigger={buttonPopUp_Login} setTrigger={setButtonPopUp_Login} setSignUpTrigger={setButtonPopUp_SignUp}></LoginPopUp>

            <SignUpPopUp trigger={buttonPopUp_SignUp} setTrigger={setButtonPopUp_SignUp} setLoginTrigger={setButtonPopUp_Login}></SignUpPopUp>

        </div>
    )
}

export default Navbar